import { createRef, Fragment, useEffect, useRef, useState } from 'react';
import NavHeader from '../../common/NavHeader/NavHeader';
import CustomContainer from '../../common/wrapper/Container';
import VerticalStack from '../../common/wrapper/VerticalStack';
import CustomeHeading from '../../customeHeading/customeHeading';
import { useSelector } from 'react-redux';
// import AppTabContainer from '../../common/tabs/AppTabContainer';
// import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { BOOKING_LINK_STEP, TREATMENT_FILTER_SETTINGS } from './constants';
// import AppTab from '../../common/tabs/AppTab';
import { GetTreatmentsForUser } from '../../redux/actions/treatmentList/getTreatmentsForUser';
import classes from './booking-link.module.scss';
import CustomeSearchBar from '../../customeSearchBar/customeSearchBar';
import classNames from 'classnames';
import TreatmentItem, { TreatmentItemSkeleton } from './treatment-item/TreatmentItem';
import SectionHeader from '../../common/typography/SectionHeader';
import Skeleton from 'react-loading-skeleton';
// import SkeletonLoader from '../../common/Skeleton/SkeletonLoader';
import TreatmentDetailsPopup from './treatment-item/TreatmentDetailsPopup';
// import { Scrollspy } from '@makotot/ghostui';
import { AppTitle } from '../../common/typography/app-text';
// import useWindowDimensions from '../../../utils/useWindowDimensions';
import { toastV2 } from '../../common/CustomToast/toastV2';
import { APP_COMPONENT_SIZE } from '../../../utils/constants';
import TreatmentCategoryTabs from './TreatmentCategoryTabs';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { webBaseUrl } from '../../../config';
import CustomModal from '../../modal/CustomModal';
import StepButton from '../../common/StepButton';

const SkeletonComponent = () => {
    return (
        <>
            <div>
                <CustomeHeading Title="Select treatment" />
                <div className={classes.categoryTabsSkeleton}>
                    <Skeleton height={32} width={100} borderRadius={20} />
                    <Skeleton height={32} width={100} borderRadius={20} />
                    <Skeleton height={32} width={100} borderRadius={20} />
                </div>
            </div>

            <div>
                <Skeleton height={50} width={'100%'} borderRadius={100} />
            </div>
            <div className={classNames(classes.listContainer, classes.treatmentListContainer)}>
                <VerticalStack space={20}>
                    {[...Array(3)].map((_, index) => (
                        <Fragment key={index}>
                            <div>
                                <Skeleton height={20} width={200} borderRadius={6} />
                            </div>
                            {[...Array(3)].map((_, tIndex) => (
                                <TreatmentItemSkeleton key={tIndex} />
                            ))}
                        </Fragment>
                    ))}
                </VerticalStack>
            </div>
        </>
    );
};

function SelectTreatment({
    setStep,
    step,
    setSelectedTreatment,
    selectedTreatment,
    clinicId,
    onTreatmentChange,
    selectedClinicSlug
}) {
    
    const sliderRef = useRef(null);
    const treatmentRef = useRef(null);
    const treatmentListContainerRef = useRef(null);
    // const { width } = useWindowDimensions();
    const { slug } = useParams()
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();

    const [sectionRefs, setSectionRefs] = useState([]);
    const [filterList, setFilterList] = useState([]);
    const [checkedValues, setCheckedValues] = useState({});
    // const [activeTabIndex, setActiveTabIndex] = useState(null);
    const [treatmentDetails, setTreatmentDetails] = useState({
        slug: '',
        treatmentId: 0,
        category_id: 0,
    });
    const [treatmentDataToBeOPenInModal, setTreatmentDataToBeOPenInModal] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [noItemsFound, setNoItemsFound] = useState(false);
    // const [slide, setSlide] = useState(0);
    const [isConfirmationModel, setIsConfirmationModel] = useState(false);

    const { treatmentList } = useSelector((state) => state.businessTreatmentsListReducer);
    const treatmentData = treatmentList?.items;

    const { initGetTreatmentsForUser, userTreatmentsQueryData } = GetTreatmentsForUser();

    const scrollTreatmentIntoView = (id) => {
        const treatment = document.querySelector(`[data-treatment-id="${id}"]`);
        if (treatment) {
            treatment.scrollIntoView({ behavior:'smooth', block:'center' });
        }
    }

    useEffect(() => {
        if (searchParams.get('treatment_id') && treatmentData?.length > 0) {
            const selectedIds = [];
            treatmentData?.forEach((item, index) => {
                item?.treatments?.forEach((treatment, tIndex) => {
                    if (
                        treatment.id == treatmentList?.treatment_DB_id &&
                        !selectedIds.includes(treatment.id)
                    ) {
                        // selectedTreatment.push(treatment)
                        selectedIds.push(treatment.id);
                        setSelectedTreatment((prevSelectedTreatments) => {
                            return [...prevSelectedTreatments, treatment];
                        });
                        setTimeout(() => {
                            scrollTreatmentIntoView(treatment.id);
                        }, 0);
                    }
                });
            });
            searchParams.delete('treatment_id');
            setSearchParams(searchParams);
        }
    }, [treatmentData]);

    // let autoScroll = 3;

    // if (width <= 576) {
    //     autoScroll = 1;
    // }

    // const handleSlickNext = (data) => {
    //     setSlide(data);
    //     if (sliderRef) {
    //         sliderRef?.current?.slickNext();
    //         sliderRef?.current?.slickGoTo(data);
    //     }
    // };
    // const handleSlickPrev = (data) => {
    //     setSlide(data);
    //     if (sliderRef) {
    //         sliderRef?.current?.slickPrev();
    //         sliderRef?.current?.slickGoTo(data);
    //     }
    // };

    const handleCheckboxChange = (category_id, treatmentId) => {
        // Append the found treatment to the selectedTreatments array

        setSelectedTreatment((prevSelectedTreatments) => {
            const category = treatmentData?.find((item) => item?.category_id === category_id);
            const treatment = category?.treatments?.find((t) => t?.id === treatmentId);
            // find if treatment is already part of prevSelectedTreatments
            const existingTreatmentObj = prevSelectedTreatments.find((t) => t.id === treatmentId);

            if (treatment) {
                // if treatment selection changes we need to reset selected date and time
                onTreatmentChange();

                // If the treatment is checked, add it to the selectedTreatments array
                if (existingTreatmentObj) {
                    return prevSelectedTreatments.filter((t) => t.id !== treatment.id);
                }
                toastV2('Treatment added');
                return [...prevSelectedTreatments, treatment];
            }


            return prevSelectedTreatments;
        });
    };


    useEffect(() => {
        if (searchParams.get('treatmentId') && (filterList && filterList?.length > 0)) {
            const UrlTreatmentId = Number(searchParams.get('treatmentId'));
            const UrlCategoriesId = Number(searchParams.get('categoriesId'));
            setStep(BOOKING_LINK_STEP.TREATMENT)
            if (filterList) {

                const treatment = treatmentData?.flatMap(item => item?.treatments || []).find(t => t?.id === UrlTreatmentId);
                setSelectedTreatment([treatment]);
                console.log(treatment, 'SelectTreatment');
                searchParams.delete('treatmentId');
                setSearchParams(searchParams);
                toastV2(`${treatment?.name} has been added to the basket. Please select more treatments or continue with your booking.`);
                // console.log('elementchecked :>> ', document.querySelectorAll(`[data-treatment-id="${treatment?.id}"]`));
                if (document.querySelector(`[data-treatment-id="${treatment?.id}"]`)) {
                    document.querySelectorAll(`[data-treatment-id="${treatment?.id}"]`)[1].scrollIntoView({
                        // top: treatment.offsetTop,
                        behavior: 'smooth',
                        // block: 'center'
                    });
                }
            }
        }
    }, [searchParams, filterList]);

    //     let categoryItem = document.getElementById(item.category_id.toString());
    //     if (categoryItem) {
    //         treatmentListContainerRef.current.scroll({
    //             top: categoryItem.offsetTop,
    //             behavior: 'smooth',
    //         });
    //         setTimeout(() => {
    //             setActiveTabIndex(null);
    //         }, 1000);
    //     }
    // };

    useEffect(() => {
        // Calculate the total price when the checkedValues state changes
        // convert the selectedTreatment array to an object with the treatment id as the key
        const newCheckedValues = {};
        selectedTreatment.forEach((treatment) => {
            newCheckedValues[treatment.id] = treatment;
        });
        setCheckedValues(newCheckedValues);
    }, [selectedTreatment]);

    useEffect(() => {
        const clinicSlug = searchParams.get('clinicSlug');
        console.log('clinicId: ', clinicId);
        if (clinicId && clinicSlug) {
            if (treatmentList?.length === 0) {
                initGetTreatmentsForUser({
                    clinicId: clinicId,
                    clinicSlug: clinicSlug
                });
            }
        }
    }, [clinicId]);

    // useEffect(()=>{
    //     if(selectedClinicSlug?.clinic_slug){
    //         const clinicslug = encodeURIComponent(selectedClinicSlug?.clinic_slug);
    //         window.location.href = `${nextjsBaseUrl}/clinics/${clinicslug}`;
    //     }
    // })
    

    useEffect(() => {
        // Set filterList to the initial treatmentData when the component first loads
        setFilterList(treatmentData);

        if (treatmentData?.length > 0) {
            const newSectionRef = treatmentData?.map(() => createRef());
            setSectionRefs(newSectionRef);
        }
    }, [treatmentData]);

    const handleOpenModal = (slug, category_id, treatmentId, data) => {
        setTreatmentDetails({
            slug: slug,
            treatmentId: treatmentId,
            category_id: category_id,
        });
        setTreatmentDataToBeOPenInModal(data);
        setIsOpen(true);
    };

    const handleSearch = (query) => {
        if (query.trim() !== '') {
            const filteredList = treatmentData?.map((item) => {
                const treatmentsInCategory = item?.treatments?.filter((data) => {
                    return (
                        data.name.toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
                        item.category_name.toLowerCase().indexOf(query.toLowerCase()) !== -1
                    );
                });

                return {
                    ...item,
                    treatments: treatmentsInCategory,
                };
            });

            if (filteredList.map((i) => i.treatments).flat().length > 0) {
                setFilterList(filteredList);
                setNoItemsFound(false);
            } else {
                setNoItemsFound(true);
            }
        } else {
            setNoItemsFound(false);
            setFilterList(treatmentData);
        }
    };

    // const handleAutoScroll = (index) => {
    //     if (index > slide && index % autoScroll === 0 && index !== 0) {
    //         handleSlickNext(index);
    //     } else if (index < slide) {
    //         handleSlickPrev(index);
    //     }
    // };

    // const handleAutoScrollMobile = debounce((index) => {
    //     document
    //         .querySelector(`[data-category-tab-id="category-tab-${index}"]`)
    //         ?.scrollIntoView({ behavior: 'smooth' });
    // }, 100);

    // useEffect(() => {
    //     window.onbeforeunload = (event) => {
    //         const e = event || window.event;
    //         // Cancel the event
    //         e.preventDefault();
    //         if (e) {
    //           e.returnValue = ''; // Legacy method for cross browser support
    //         }
    //         return ''; // Legacy method for cross browser support
    //       };
    // }, []);


    
    return (
        <>
            <CustomContainer removeTopPadding>
                <VerticalStack className={classes.treatmentSection}>
                    <NavHeader
                        isSticky
                        isBackOnly
                        // handleOnBack={() => setStep(BOOKING_LINK_STEP.LOCATION)}
                        handleOnBack={() => {
                            setIsConfirmationModel(true)
                            // const clinicslug = encodeURIComponent(selectedClinicSlug?.clinic_slug);
                            // window.location.href = `${nextjsBaseUrl}/clinics/${clinicslug}`;
                        }}

                    />
                    {userTreatmentsQueryData.loading ||
                        (!userTreatmentsQueryData.called && treatmentList?.length === 0) ? (
                        <SkeletonComponent />
                    ) : (
                        <>
                            <div>
                                <CustomeHeading 
                                Title="Select treatment"
                                Desc="Add, or update treatments for your booking" />
                                <TreatmentCategoryTabs
                                    tabList={filterList}
                                    sectionRefs={sectionRefs}
                                    scrollCategory={(offset) => {
                                        treatmentListContainerRef.current.scroll({
                                            top: offset,
                                            behavior: 'smooth',
                                        });
                                    }}
                                />
                                {/* <AppTabContainer className={classes.categoryTabs}>
                                    {filterList?.length > 0 && (
                                        <Scrollspy
                                            sectionRefs={sectionRefs}
                                            rootSelector="#my-list-root"
                                        >
                                            {({ currentElementIndexInViewport }) => (
                                                <>
                                                    {handleAutoScroll(
                                                        currentElementIndexInViewport
                                                    )}
                                                    <Slider
                                                        {...TREATMENT_FILTER_SETTINGS}
                                                        arrows={false}
                                                        ref={sliderRef}
                                                    >
                                                        {filterList?.map((item, index) => {
                                                            return (
                                                                <AppTab
                                                                    shallTruncate
                                                                    // isActive={
                                                                    //     currentElementIndexInViewport ===
                                                                    //     index
                                                                    // }
                                                                    isActive={
                                                                        activeTabIndex === index ||
                                                                        (currentElementIndexInViewport ===
                                                                            index &&
                                                                            !activeTabIndex)
                                                                    }
                                                                    ref={sectionRefs[index]}
                                                                    className={classes.categoryTab}
                                                                    key={item?.category_id}
                                                                    onClick={() => {
                                                                        handleChangeCategory(
                                                                            item,
                                                                            index
                                                                        );
                                                                    }}
                                                                    title={item?.category_name}
                                                                >
                                                                    {item?.category_name}
                                                                </AppTab>
                                                            );
                                                        })}
                                                    </Slider>
                                                </>
                                            )}
                                        </Scrollspy>
                                    )}
                                </AppTabContainer> */}
                            </div>
                            <CustomeSearchBar
                                onSearch={handleSearch}
                                SearchPlaceholder="Search treatment"
                            />
                            <div
                                className={classNames(
                                    classes.listContainer,
                                    classes.treatmentListContainer
                                )}
                                id="my-list-root"
                                ref={treatmentListContainerRef}
                            >
                                <VerticalStack space={15}>
                                    {filterList?.length > 0 &&
                                        !noItemsFound &&
                                        filterList?.map((item, index) => {
                                            const MainTreatmentHeight = treatmentListContainerRef.current.getBoundingClientRect().height;
                                            const isLastCategory = index === filterList.length - 1;
                                            const maxEls = Math.floor(MainTreatmentHeight / 77);
                                            const hasThreeOrMoreTreatments = item?.treatments?.length < maxEls;
                                            const MainTreatmentDivHeight = 77 * item?.treatments?.length + 15 * (item?.treatments?.length - 1);
                                            const TotalDivHeight = MainTreatmentHeight - MainTreatmentDivHeight;
                                            // const totalBlankDiv = item?.treatments?.length < maxEls - 2 && maxEls - item?.treatments?.length;
                                            // console.log('totalBlankDiv:', totalBlankDiv);
                                            return (
                                                <div
                                                    ref={sectionRefs[index]}
                                                    id={item?.category_id?.toString()}
                                                    key={item?.category_id}
                                                >
                                                    <SectionHeader
                                                        size={APP_COMPONENT_SIZE.medium}
                                                        title={item.category_name}
                                                    />
                                                    <VerticalStack space={15}>
                                                        {item?.treatments?.map(
                                                            (treatment, tIndex) => {
                                                                return (
                                                                        <TreatmentItem
                                                                            treatId={treatment?.id}
                                                                            onOpenTreatmentDetails={() =>
                                                                                handleOpenModal(
                                                                                    treatment?.slug,
                                                                                    item?.category_id,
                                                                                    treatment?.id,
                                                                                    treatment
                                                                                )
                                                                            }
                                                                            key={treatment?.id}
                                                                            title={treatment?.name}
                                                                            image={
                                                                                treatment?.image_url[0]
                                                                            }
                                                                            duration={
                                                                                treatment.duration
                                                                            }
                                                                            isChecked={
                                                                                !!checkedValues[
                                                                                treatment?.id
                                                                            ]
                                                                        }
                                                                        onChange={() =>
                                                                            handleCheckboxChange(
                                                                                item?.category_id,
                                                                                treatment?.id
                                                                            )
                                                                        }
                                                                        price={treatment.amount}
                                                                        rating={
                                                                            treatment.average_review_rating
                                                                        }
                                                                        reviewCount={
                                                                            treatment?.total_review_count
                                                                        }
                                                                        treatmentId={treatment?.id}
                                                                    />
                                                                );
                                                            }
                                                        )}
                                                    </VerticalStack>

                                                      {/* Add spacer only after the last category with >= 3 treatments */}
                                                      
                                                        {isLastCategory && hasThreeOrMoreTreatments && (
                                                        // [...Array(totalBlankDiv)].map((_, index) => (
                                                            <div key={`spacer-${index}`} style={{ height: TotalDivHeight - 35 + 'px' }} />
                                                        // ))
                                                        )}
                                                </div>
                                            );
                                        })}
                                    {noItemsFound && (
                                        <AppTitle className="text-center mt-5">
                                            No results found for your search
                                        </AppTitle>
                                    )}
                                </VerticalStack>
                            </div>
                        </>
                    )}
                </VerticalStack>
            </CustomContainer>
            <TreatmentDetailsPopup
                setStep={setStep}
                step={step}
                treatmentDetails={treatmentDetails}
                isAdded={selectedTreatment?.find((i) => i.id === treatmentDataToBeOPenInModal?.id)}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                selectedTreatment={selectedTreatment}
                treatmentDataToBeOPenInModal={treatmentDataToBeOPenInModal}
                setSelectedTreatment={setSelectedTreatment}
            />

            <CustomModal
                modalOpen={isConfirmationModel}
                setModalOpen={setIsConfirmationModel}
                modaltitle={"Are you sure?"}
                className={'customConfimationModel'}
                modelDescShow={true}
                modelDesc={'You may lose the selected treatment. Do you want to proceed?'}
                modalBody={
                    <div className='btnWrapper'>
                        <StepButton className='blueBtn' label={'Yes'} onClick={() => {
                            const clinicslug = encodeURIComponent(selectedClinicSlug?.clinic_slug);
                            window.location.href = `${webBaseUrl}/clinics/${clinicslug}`;
                            setIsConfirmationModel(false)
                        }} />
                        <StepButton className='greyBtn' label={'No'} onClick={() => {
                                setIsConfirmationModel(false)
                        }}/>
                    </div>
                }
            />
        </>
    );
}
export default SelectTreatment;
